export const en = {
  common: {
    next: 'Next',
    verify: 'Verify',
    email_placeholder: 'Enter your email',
    email_invalid: 'Invalid email',
    email_required: 'Email is required',
    password_placeholder: 'Enter your password',
    password_required: 'Password is required',
    password: 'Password',
    close: 'Close',
    default_error_message: 'An unexpected error occurred. Please try again.',
    male: 'Male',
    female: 'Female',
    scheduling: 'Schedule',
    unknown: 'Unknown',
    undifferentiated: 'Undifferentiated',
    md: 'Dr.',
    payment_method: 'Payment method',
    patient_name: 'Patient',
    type_attendance: 'Type of attendance',
    doctor_name: 'Doctor',
    date_and_time: 'Date and time',
    see_details: 'See details',
    common_connectivity_error:
      'Please try again, or check your internet connection.',
    from: 'from',
    change: 'Change',
    look: 'See',
    cancel: 'Cancel',
    save: 'Save',
    confirm: 'Confirm',
    cancel_popup_title: 'Cancel appointment?',
    cancel_popup_description:
      'Are you sure you want to cancel this appointment?',
    in_person: 'In person',
    online: 'Online',
    common_field_label_required: 'Required field',
    comming: 'Coming soon',
    warning_cancelarion_refund_title: 'Cancellation (Credit Card)',
    warning_cancelarion_refund: 'Full refund',
    warning_cancelarion_no_refund: 'No refund',
    hours_ahead: 'hours ahead',
    hours_behind: 'hours behind',
    same_time: 'Same time',
  },

  auth: {
    forgot_password: 'Forgot password?',
    remember_me: 'Remember me',
    login_button: 'Login',
    create_account: 'Create account',
    warning_description:
      'We encountered a technical issue while trying to complete your registration. Please try again.',
    warning_left_button: 'Go to home',
    warning_right_button: 'Try again',
    'Incorrect username or password.': 'Incorrect email or password.',
    success_token: 'Your code has been validated',
  },
  create_new_password: {
    code_resend_error: 'Error resending the code. Please try again.',
    code_resent_info: 'Code successfully resent to email: {{email}}',
    email_sent_code:
      'We sent a 6-digit code to your email: <strong>{{email}}</strong>',
    password_confirmation_required: 'Password confirmation is required',
    enter_your_new_password: 'Enter your new password',
    confirm_your_new_password: 'Confirm your new password',
    confirm_password: 'Confirm password',
    password_requirements_title: 'Your password must contain:',
    has_eight_characters: 'At least 8 characters',
    has_one_number: 'At least 1 number',
    has_one_letter: 'At least 1 letter',
    btn_create_password: 'Create password',
    title_forgot_password: 'Forgot your password',
    verify_your_email: 'Verify your email',
    required_code: 'The code is required',
    min_length_password: 'Password must be at least 8 characters',
    password_has_number: 'Password must contain at least 1 number',
    password_has_letter: 'Password must contain at least 1 letter',
    password_not_match: 'Passwords do not match',
    title_code_verification: 'Verification code',
    resend_code: 'Resend',
    subtitle_create_new_password:
      'Create a new password to protect your account!',
    expiration_time: 'The code expires in ',
    not_received_code: "Didn't receive the code?",
    'Invalid verification code provided, please try again.':
      'Invalid verification code provided, please try again.',
  },
  forgot_password: {
    error_sending_email: 'Error sending email. Please try again.',
    btn_email_sent: 'Send Email',
    email_sent: 'Email sent',
    forgot_password_title: 'Forgot your password',
    forgot_password_subtitle: 'Register a new password',
    forgot_description:
      'To register a new password, please provide the email associated with your account.',
    resend_code_title: 'Resend code',
    account_validation_title: 'Account Validation',
    account_validation_description:
      'If you want to validate this email, please proceed. We will send an email with the account validation code.',
  },
  home: {
    title_next_scheduling: 'Next Schedulings',
    see_more: 'See More',
    service_title: 'Services',
    empty_state_title: 'No appointments scheduled',
    empty_state_description:
      'Schedule your appointment and enjoy personalized medical care.',
    schedule_consultation: 'Schedule consultation',
    available_on: 'Available on',
    appstore: 'App Store',
    playstore: 'Play Store',
    qr_code_instruction: 'Scan the QR Code to download the app!',
    title: 'Get access to everything!',
    description:
      'Access more functionalities in the app! Download to register dependents, view history and more.',
  },
  banner: {
    banner_title: 'Get access to everything!',
    banner_description:
      'Access more features in the app! Download to register dependents, view history, and more.',
    banner_available_in_masc: 'Available on',
    banner_available_in_fem: 'Available on',
    banner_google_play: 'Google Play',
    banner_app_store: 'App Store',
    banner_scan_qr_code: 'Scan the QR Code to download the app!',
  },
  signInPersonalInfo: {
    create_account_title: 'Create account',
    create_account_step_1_subtitle:
      "Let's get started!\n Tell us a little about yourself",
    create_account_name: 'Name',
    create_invalid_name: 'First name is required',
    create_invalid_name_less_3: 'First name must be at least 3 characters long',
    create_account_surname: 'Surname',
    create_invalid_surname: 'Surname is required',
    create_invalid_surname_less_3:
      'Last name must be at least 3 characters long',
    create_account_birthdate: 'Birthdate',
    create_invalid_birthdate: 'Birthdate is required',
    create_account_email: 'Email',
    create_invalid_email: 'Email is required',
    create_account_phone: 'Phone',
    create_invalid_phone: 'Phone is required',
    create_less_min_phone_number:
      'Phone must be at least {{minLength}} characters',
    create_invalid_country_code: 'Invalid DDI',
    create_account_gender: 'Biological sex',
    create_account_invalid_gender: 'Biological sex is required',
    create_account_email_already_registered: 'Email already registered!',
    login_account_email_already_registered_description:
      'This email is already registered but still needs to be verified. Confirm it now or use another email to continue.',
    create_account_email_already_registered_resend_password: 'Reset password',
    create_account_email_already_registered_change_email: 'Change email',
    create_account_email_already_registered_verify_email: 'Verify email',
  },
  signInAddress: {
    create_account_step_2_subtitle: 'Stay chill, your infos are safe with us',
    create_account_zip: 'Zip code',
    create_account_invalid_zip: 'Zip code is required',
    create_account_invalid_zip_number: 'Zip code is not a number',
    create_account_invalid_less_min:
      'Zip code must be at least 5 characters long',
    create_account_address: 'Address',
    create_account_invalid_address: 'Address is required',
    create_account_city: 'City',
    create_account_invalid_city: 'City is required',
    create_account_state: 'State',
    create_account_invalid_state: 'State is required',
    create_account_complement: 'Complement',
    create_account_zip_auto_fill_error: 'Invalid zip code',
  },
  signInPassword: {
    create_account_step_3_subtitle: 'Almost there, password time',
    create_account_password: 'Password',
    create_account_confirm_password: 'Repeat password',
    create_account_required_title: 'Your password must contain:',
    create_account_length: 'Has 8 digits',
    create_account_one_number: 'Has at least 1 number',
    create_account_one_letter: 'Has at least 1 letter',
    create_account_allow_privacy: 'Privacy politics',
    create_account_allow_text: 'Allow with',
    create_account_terms_middle: 'and with the',
    create_account_terms_end: 'of the app',
  },
  signInCode: {
    create_account_step_4_subtitle: 'Verify your email',
  },
  success: {
    sign_in_success_title: 'Account registered successfully!',
    sign_in_success_description:
      'You can now login to your account and enjoy all the services',
    sign_in_success_button: 'Go to Login',
    password_reset_success_title: 'Password changed successfully!',
  },
  successView: {
    title: 'Account created successfully!',
    description: 'You can now login to your account and enjoy all the services',
    button_title: 'Go to Login',
  },
  appointmentDetails: {
    page_title: 'Upcoming Appointments',
    appoitment_title: 'Your Appointment Information',
    appoitment_description: 'Appointment Summary',
    payment_title: 'Payment Summary',
    reschedule_appointment: 'Reschedule Appointment',
    cancel_appointment: 'Cancel Appointment',
    local_payment: 'Local Payment',
    total_value: 'Total Value',
    back_to_home_btn: 'Back',
    view_address: 'View Address',
    access_consultation: 'Access Consultation',
    online_consultation: 'Online consultation',
    cannot_cancel:
      'You can no longer reschedule, your appointment is about to start! Cancel without a refund.',
    you_can_cancel_or_reschedule_basic: 'You can cancel or reschedule',
    you_can_cancel_or_reschedule:
      'You can cancel or reschedule until {{date}} at {{time}}',
    cancellation_no_refund_reschedule_available:
      'Cancellation available without refund. You can reschedule at no cost until {{date}} at {{time}}',
    you_can_cancel_or_reschedule_with_refund:
      'You can cancel with a refund or reschedule your appointment',
    you_can_cancel_or_reschedule_no_refund:
      'You can cancel without a refund or reschedule your appointment',
    online_consultation_available: 'Active 15 min before the appointment',
  },
  schedule: {
    schedule_title: 'New Schedule',
    schedule_choose_user_subtitle:
      "Let's get started!\nSelect who you want to serve",
    schedule_choose_appointment_type_title: 'Choose the best location',
    schedule_choose_appointment_in_person_location_title:
      'Choose appointment type ',
    schedule_choose_appointment_type_online: 'Online Consultation',
    schedule_choose_appointment_type_in_person: 'In-person Consultation',
    schedule_choose_doctor_title: 'Select the doctor you want',
    screen_choose_doctor_no_prefence: "I don't have a preference",
    screen_choose_date_times_title: 'Available Times',
    screen_choose_date_no_time:
      'All times for <bold>{{ date }}</bold> are booked. Choose another day.',
    screen_choose_date_title: 'Select date and time',
    screen_choose_payment_title: 'Select payment method',
    screen_choose_confirm_title: 'Check all information',
    screen_choose_payment_card: 'Credit card',
    screen_choose_pay_locally: 'Pay locally',
    screen_choose_add_payment_in_card: 'Register a new card',
    screen_choose_pay_total_value: 'Total value',
    screen_choose_before_confirm_appointment_subtitle:
      'before confirming the appointment!',
    screen_choose_confirm_schedule_title: 'Check all information',
    // screen_choose_confirm_schedule_type: 'Schedule type',

    screen_choose_confirm_schedule_schedule_type: 'Schedule type',
    screen_choose_confirm_schedule_patient: 'Patient',
    screen_choose_confirm_schedule_doctor: 'Doctor',
    screen_choose_confirm_schedule_date_time: 'Date and time',
    screen_choose_confirm_schedule_time: 'Times',
    screen_choose_confirm_schedule_payment_type: 'Payment type',
    screen_choose_confirm_schedule_appointment_price: 'Inquiry value',
    screen_choose_confirm_schedule_discount_price: 'Medstation Card Discount',
    screen_schedule_success:
      'Appointment successfully confirmed! You can now check your information and manage your appointment schedules.',
    screen_reschedule_success:
      'Appointment successfully changed! You can now check your information and manage your appointment schedules.',
    re_schedule_popup_title: 'Reschedule appointment?',
    re_schedule_popup_description:
      'Cant make it to your appointment? Reschedule right now.',
    screen_schedule_medstationcard_title: 'Discover the Medstation Card',
    screen_schedule_medstationcard_text:
      'Consultations, procedures, and exams with a discount',
    screen_schedule_confirm: 'Confirm appointment',
    screen_get_reschedule_error:
      'Error in rescheduling, please confirm schedule id and try again',
    schedule_no_locations_available: 'No locations available',
    modal_error_payment_credit_card_title: 'Oops! Something went wrong',
    modal_error_payment_credit_card_description:
      'There was an error processing your payment. Please check your card information.',
    reschedule: 'Reschedule',
  },
  creditCard: {
    screen_credit_card_title: 'Credit Card',
    screen_credit_card_subtitle: 'Select, or register a new credit card',
    screen_credit_card_register_new: 'Register new card',
    screen_credit_card_delete_popup_title: 'Delete card?',
    screen_credit_card_delete_popup_description:
      'No credit cards registered. Add a new credit card to continue with the appointment.',
    screen_credit_card_empty_state_title: 'Register new credit card',
    screen_credit_card_empty_state_description:
      'No card registered. Add a card to continue scheduling.',
    screen_credit_card_register_title: 'Register new credit card',
    screen_credit_card_register_description:
      'Fill in the credit card details you wish to register',
    screen_credit_card_register_number: 'Credit Card Number',
    screen_credit_card_register_name: 'Name Printed on Card',
    screen_credit_card_register_date: 'Expiration Date (MM/YY)',
    screen_credit_card_register_code: 'Security Code',
    screen_credit_card_register_number_btn: 'Click to fill in the card number',
  },
  popup: {
    reschedule_appointment: 'Reschedule appointment',
    cancel_appointment: 'Cancel appointment',
    shure_cancel_appointment: 'Are you sure you want to cancel?',
    cancel_description:
      'Cannot attend your appointment? Instead of canceling, you can reschedule now.',
  },
  whatsAppPopup: {
    whatsAppPopup_title: 'Consultation with health insurance?',
    whatsAppPopup_description:
      'Schedule your appointment with health insurance via WhatsApp. For credit card or Medhelp payments, continue here.',
    whatsAppPopup_stay_here: 'Continue here',
    whatsAppPopup_go_to_whatsapp: 'Go to Whatsapp',
  },
  privacyPolicy: {
    create_password: 'Create password',
    privacy_policy: 'Privacy Policy',
    how_we_use_and_store: 'How we use and store your data',
    last_updated: 'Last updated on August 16, 2024',
    introduction: 'Introduction',
    welcome_message:
      'Welcome to MedStation. Your privacy and data security are our highest priorities. This Privacy Policy describes how we collect, use, share, and protect your personal information when using our application. We are committed to complying with all applicable laws and regulations, including the ',
    hipaa: 'Health Insurance Portability and Accountability Act (HIPAA).',
    data_collection_title: 'Data Collection',
    data_collection_description: 'What data we collect',
    data_use_title: 'Data Use',
    data_use_description: 'How we use your data',
    data_security_title: 'Data Security',
    data_security_description: 'How we protect your data',
  },
  dataCollection: {
    title: 'Privacy Policy',
    section1_title: 'Data Collection',
    section1_subtitle: 'What data we collect',
    section1_item1:
      '• Personal Information: Name, date of birth, contact information (email, phone), and address.',
    section1_item2:
      '• Health Information: Medical history, health conditions, prescriptions, consultation history.',
    section2_title: 'How we collect',
    section2_item1:
      '• Directly from you during the registration process, when scheduling appointments, or interacting with the app.',
    section2_item2:
      '• When registering dependent information in the app, you declare that you are authorized to share this data and agree on their behalf to the terms of this policy.',
  },
  dataUse: {
    title: 'Privacy Policy',
    section1_title: 'Use of Data',
    section1_subtitle: 'Why we use your data',
    section1_item1:
      '• To manage your medical appointments and those of any dependents you register.',
    section1_item2:
      '• To provide personalized and efficient healthcare services.',
    section1_item3:
      '• To send reminders and notifications related to your health and appointments.',
    section2_title: 'Data Sharing',
    section2_item1:
      '• With your healthcare professionals: To ensure coordinated and effective care.',
    section2_item2:
      '• With trusted third parties: Only with your consent and when necessary, such as laboratories for testing or health insurers.',
  },
  dataSecurity: {
    title: 'Privacy Policy',
    section_title: 'Data Security',
    section_subtitle: 'How we protect your data',
    item1_description:
      '• HIPAA Compliance: We strictly adhere to all HIPAA regulations that protect patient health information.',
    item2_description:
      '• Encryption: All your data is encrypted both in transit and at rest, ensuring that your information remains secure.',
    item3_description:
      '• Access Control: Only authorized personnel have access to your data, and only for legitimate and specific purposes.',
    item4_description:
      '• Confidentiality: All data you share with us is treated as confidential and protected by strict security measures. We do not disclose your personal information without your express consent, except for the provision of medical services or as required by law.',
  },
  appointment: {
    next_appointments: 'Next appointments',
    all_appointments: 'All appointments',
    empty_filter:
      'No results found with the selected filter. Try adjusting the filter or resetting it to view the appointments.',
    load_more: 'Load more',
  },
  filter: {
    all_the_appointments: 'All appointments',
    only_my_appointments: 'Only my appointments',
    only_my_dependents: 'Only my dependents',
    apply: 'Apply',
    clear: 'Clear all',
  },
  logout: {
    title: 'Log out of your account?',
    description: 'You are about to log out. Are you sure you want to log out?',
    lang_en: 'English',
    lang_es: 'Spanish',
    lang_pt: 'Portuguese',
    short_en: 'EN',

    short_es: 'ES',
    short_pt: 'PT',
  },
  deleteAccount: {
    delete_account_title: 'Delete Account',
    title: 'Delete Account in medstation',
    description: 'How to delete my account and all my information',
    section_title: 'Steps',
    section_description: `•\tLog in to the app\n•\tGo to your profile area (click on your profile picture or where your initials are, in the top left corner)\n•\tIn the options, select 'Security and Privacy'\n•\tSelect 'Delete Account'\n•\tRead and check all the options to confirm the removal of your data, and click on 'Delete Account'\n•\tDone, your account has now been completely removed`,
  },
  termsOfUse: {
    create_password: 'Create Password',
    title: 'Terms of Use',
    description: 'How to properly use our services',
    section_title: 'Introduction',
    section_description:
      'The use of our services is subject to the following terms and conditions, which describe the responsibilities and obligations of users when using the application. By agreeing to these Terms of Use, you acknowledge that this agreement applies to both you and any dependents you register in the application, ensuring appropriate and secure use of the platform.',
    top_button_title: 'Telemedicine',
    top_button_description: 'How and when to use the service',
    bottom_button_title: 'Cancellation Policy',
    bottom_button_description: 'How we handle cancellations and refunds',
  },
  telemedicine: {
    title: 'Telemedicine',
    description: 'How and when to use the service',
    last_updated: 'Last updated on August 16, 2024',
    presection_description:
      'By using our application to schedule telemedicine appointments, you consent to the following terms and conditions:',
    section1: 'Consultation Modalities',
    section1_description:
      '• Telemedicine consultations can be conducted via video call, phone call, or text chat, depending on availability and agreement with the healthcare provider.',
    section2: 'Telemedicine Limitations',
    section2_description1:
      '• You acknowledge that telemedicine provides care without a physical examination, and therefore is not recommended for medical emergencies. In case of an emergency, you should immediately call emergency services (such as 911).',
    section2_description2:
      '• You understand that consultation scheduling may be subject to delays or rescheduling due to more urgent medical priorities.',
    section3: 'Risks Associated with Telemedicine',
    section3_description1:
      '• Communication failures between you and the healthcare provider may occur during the telemedicine session. These failures may impact care and diagnosis.',
    section3_description2:
      '• Telemedicine may have limitations, including but not limited to:',
    section3_description2_sub1:
      '• Restrictions or unavailability of exams, prescriptions, and other medical records;',
    section3_description2_sub2:
      '• Difficulties for the healthcare provider to conduct a detailed physical assessment, which may affect the diagnosis;',
    section3_description2_sub3:
      '• Delays in diagnosis or treatment due to technical problems, connection failures, or data loss.',
    section3_description3:
      '• You acknowledge that these factors may interfere with care and will not hold Medstation responsible for possible delays or data losses due to technological failures.',
    section4: 'Data Security',
    section4_description1:
      '• The use of electronic communication involves inherent risks. Despite efforts to ensure security, there is a possibility that digital data may be intercepted, modified, or accessed by third parties.',
    section4_description2:
      '• You are responsible for using a secure network when participating in a telemedicine consultation.',
    section4_description3:
      '• You understand that even with reasonable measures to protect confidentiality, technical failures may compromise the transmission of your medical records.',
  },
  cancellationPolicy: {
    title: 'Cancellation Policy',
    description: 'How we handle cancellations and refunds',
    last_updated: 'Last updated on August 16, 2024',
    presection_description:
      'By using our application to schedule telemedicine appointments, you consent to the following terms and conditions:',
    section1: 'Cancellation with Refund',
    section1_description:
      '• Cancellations must be made at least 24 hours in advance to ensure the right to a refund.',
    section2: 'Rescheduling',
    section2_description:
      '• Appointments can be rescheduled at no cost up to 3 hours in advance. After this period, rescheduling will not be allowed.',
    section3: 'Credit Card Refund',
    section3_description:
      '• Payments made via credit card will be refunded in accordance with the card issuer policies. The refund timeline may vary depending on the financial institution.',
    section4: 'In-Person Appointment Cancellation',
    section4_description1:
      '• In-person appointments can be canceled or rescheduled up to 3 hours in advance.',
    section4_description2:
      '• If the payment has already been made via credit card, the amount will be refunded according to the card issuer policies. The refund timeline may vary depending on the financial operator.',
    section5: 'No-Show Policy',
    section5_description1:
      '• If the patient does not attend the telemedicine appointment, our team will contact the patient twice by phone to attempt to reschedule the appointment. If there is no response, a refund will not be granted.',
    section5_description2:
      '• If the patient does not attend the in-person appointment, no refund will be granted, even if payment has already been made.',
    bottom_description:
      'Refunds will not be granted for cancellations related to issues beyond our control, such as problems with pharmacies or medications.',
  },
};
